import { jsx } from "react/jsx-runtime";
import React from "react";
import { Icon, Menu } from "@blueprintjs/core";
import { createCommandMenu } from "@teselagen/ui";
import getCommands from "../commands";
import { connectToEditor } from "../withEditorProps";
import ToolbarItem from "./ToolbarItem";
import withEditorProps from "../withEditorProps";
export default connectToEditor()(({ toolbarItemProps }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        tooltip: "Export",
        Dropdown,
        noDropdownIcon: true,
        onIconClick: "toggleDropdown",
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "veDownloadTool", icon: "import" }),
        ...toolbarItemProps
      }
    }
  );
});
const Dropdown = withEditorProps((props) => {
  return /* @__PURE__ */ jsx(Menu, { children: createCommandMenu(
    [
      "exportSequenceAsGenbank",
      "exportDNASequenceAsFasta",
      "exportProteinSequenceAsFasta",
      "exportSequenceAsTeselagenJson"
    ],
    getCommands({ props })
  ) });
});
